import React, { Component } from "react";
import $ from "jquery";
import "./App.css";
import Terms from "./Legal/Terms";
import Terms113 from "./Legal/Terms113";
import Terms114 from "./Legal/Terms114";
import Privacy from "./Legal/Privacy";
import CookiePolicy from "./Legal/CookiePolicy";
import MemberPrinciples from "./Legal/MemberPrinciples";
import CommunitySafety from "./Legal/CommunitySafety";
import ChildSafety from "./Legal/ChildSafety";
import Closed from "./Legal/Closed";

// import FAQs from "./Components/FAQs";
import Home from "./Components/Home";
import Tips from "./Components/Tips";
import Subscribe from "./Components/Subscribe";
// import LanguageGuidelines from "./Components/LanguageGuidelines";
// import ScienceGuidelines from "./Components/ScienceGuidelines";
import RefreshmentsBarGuidelines from "./Components/Mechanics"




import { BrowserRouter, Routes, Route } from "react-router-dom";
import Cookies from 'universal-cookie';


class App extends Component {
  constructor(props) {
    super(props);
    const cookies = new Cookies();
    this.state = {
      foo: "bar",
      resumeData: {},
      loginCookie: cookies.get('login')
    };
  }

  getResumeData() {
    $.ajax({
      url: "./resumeData.json",
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
      }
    });
  }

  componentDidMount() {
    this.getResumeData();

  }

  handleSubmit(event) {
    event.preventDefault();
  }


  render() {
  
      return (
        <BrowserRouter>
          <div className="App">
          </div>
          <Routes>
            <Route index element={<Home data={this.state.resumeData.main} />} />
            <Route path="subscribe" element={<Subscribe />} />
            {/* <Route path="faqs" element={<FAQs />} /> */}
            {/* <Route path="faqsapp" element={<FAQs />} /> */}
            <Route path="tips" element={<Tips />} />
            <Route path="terms" element={<Terms />} />
            <Route path="terms113" element={<Terms113 />} />
            <Route path="terms114" element={<Terms114 />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="cookies" element={<CookiePolicy />} />
            <Route path="principles" element={<MemberPrinciples />} />
            <Route path="communitysafety" element={<CommunitySafety />} />
            <Route path="childsafety" element={<ChildSafety />} />
            <Route path="closed" element={<Closed />} />
            {/* <Route path="language" element={<LanguageGuidelines />} /> */}
            {/* <Route path="science" element={<ScienceGuidelines />} /> */}
            <Route path="mechanics" element={<RefreshmentsBarGuidelines />} />

          </Routes>
        </BrowserRouter>
      );
  }
}

export default App;
